const { upperFirst, words } = require('lodash');

exports.icon = (value) => {
    return value ? `$${upperFirst(words(value.replace(/ and | of /g, ' ')).slice(0, 2).join(''))}` : value;
};

exports.colors = {
    primary: '#800080',
    secondary: '#808080',
    purple: '#800080',
    grey: '#808080',
    orange: '#5C5C5C',
    lightBlue: '#1E90FF',
    navyBlue: '#191970',
    green: '#008000',
    pink: '#DC143C'
};

exports.definition = (value) => {
    switch(value) {
        case 'Cell Therapy':
            return 'Cell therapy products use living cells as a means of replacing or repairing damaged cells to treat disease.';
        case 'Gene Therapy':
            return 'Gene therapy involves the use of a vector, such as an inactivated virus, to insert a new copy of a gene or relevant nucleotide sequence into a patient’s cells to treat a genetic health condition.';
        case 'Tissue Engineering':
            return 'Tissue engineering uses scaffolds, cells, and biologically active molecules to create new, functional tissue to restore, maintain, or improve tissue or organs that have been physically damaged or affected by disease.';
        case 'Supportive':
            return 'Supportive standards are not developed specifically for cell therapy, gene therapy, or tissue engineering but are applicable to one or more of these sectors. They often can be used directly in each sector or leveraged when developing sector-specific standards because they cover many of the same functional areas.';
        case 'Bioprocessing and Production':
            return 'Bioprocessing—another way to describe biomanufacturing—involves the design and development of processes, materials, and equipment for manufacturing products from raw/ancillary biological materials.';
        case 'Analytical and Testing Methodologies':
            return 'Analytical and testing methodologies are used to detect, measure, and/or monitor certain attributes of a material and the state in which it is located.';
        case 'Product Quality and Characterization':
            return 'Product quality and characterization standards convey well-defined quality attributes (e.g., identity, quantity, purity, sterility, biological activity/potency) of materials used in regenerative medicine therapies and provide a clear understanding of their intended use. These standards guide the design of measurements with sufficient selectivity, sensitivity, resolution, and robustness to enable subsequent decision making.';
        case 'Logistics and Compliance Criteria':
            return 'Logistics and compliance involves the coordinated collection, manufacturing, and administration of cells and other therapy products across therapy manufacturers, providers, and recipients. Standards can help to ensure appropriate handling techniques, controls, and product traceability.';
        case 'Preclinical Studies':
            return 'Preclinical studies test a drug, procedure, or other medical treatment in animals and are required to take place before clinical trials in humans can begin.';
        case 'Clinical Trials':
            return 'Clinical trials are research studies that determine whether a regenerative medicine therapy is safe and effective for human use. These studies must follow strict scientific research standards to ensure patients are protected and results are reliable.';
    }
    return undefined;
};

exports.statusDisplay = (status) => {
    return 'Available' === status ? 'Published / Released' : status;
};

exports.statuses = [
    'In Development',
    'Available',
    'Withdrawn',
    'Area of Need'
];

exports.sectors = [
    'Cell Therapy',
    'Gene Therapy',
    'Tissue Engineering',
    'Supportive'
];

exports.functionalAreas = [
    'Bioprocessing and Production',
    'Analytical and Testing Methodologies',
    'Product Quality and Characterization',
    'Logistics and Compliance Criteria',
    'Preclinical Studies',
    'Clinical Trials'
];

exports.types = [
    'Documentary',
    'Reference'
];

exports.features = [
    { value: 'none', text: 'Not Featured' },
    { value: 'available', text: 'Published / Released', hint: 'Newly published documentary standards or released reference materials' },
    { value: 'recent', text: 'Recent Activity', hint: 'Recent activity includes new open ballots, calls to action, and more' },
    { value: 'new', text: 'New To The Portal', hint: 'Existing or in-development standards or areas of need recently added to the portal' },
    { value: 'revised', text: 'Revised By SDOs', hint: 'New editions or standards recently revised by standards developing organizations' }
];

exports.priorities = [
    'High urgency/low impact',
    'Medium urgency/low impact',
    'Low urgency/low impact',
    'High urgency/medium impact',
    'Medium urgency/medium impact',
    'Low urgency/medium impact',
    'High urgency/high impact',
    'Medium urgency/high impact',
    'Low urgency/high impact',
    'Pending prioritization',
    'N/A: Standardization in progress'
];
